var timer = null;

function pad(n) {
  return n < 10 ? '0' + n : String(n);
}

function render(el, end) {
  var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
  if (left === 0) {
    el.hidden = true;
    return false;
  }
  var d = Math.floor(left / 86400);
  var h = Math.floor(left % 86400 / 3600);
  var m = Math.floor(left % 3600 / 60);
  var s = left % 60;
  el.querySelector('[data-cda-countdown-time]').textContent =
    (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  el.hidden = false;
  return true;
}

document.addEventListener('turbolinks:load', function() {
  clearInterval(timer);
  var el = document.querySelector('[data-cda-countdown]');
  if (!el) return;
  var end = new Date(el.getAttribute('data-cda-countdown')).getTime();
  if (isNaN(end) || !render(el, end)) return;
  timer = setInterval(function() {
    if (!render(el, end)) clearInterval(timer);
  }, 1000);
});

document.addEventListener('turbolinks:before-cache', function() {
  clearInterval(timer);
});
